import ZTExchangePlatformModal from './ZT_exchange_platform-modal.vue'
export default ZTExchangePlatformModal
